.panel {
  height: 100%;
  border-left: 1px solid var(--color-border);
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  padding: var(--spacing-md);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.sectionTitle {
  margin: 0;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.facts {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--spacing-xs) var(--spacing-md);
  margin: 0;
  font-size: var(--font-size-sm);
}

.facts dt {
  color: var(--color-text-muted);
}

.facts dd {
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.mono {
  font-family: var(--font-mono);
}

.editors {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.note {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}
